import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const singleOrDefault = (source, predicate) => {
    if (predicate) {
        return singleOrDefault2(source, predicate);
    }
    else {
        return singleOrDefault1(source);
    }
};
const singleOrDefault1 = (source) => {
    let hasValue = false;
    let singleValue = null;
    for (const value of source) {
        if (hasValue === true) {
            throw new InvalidOperationException(ErrorString.MoreThanOneElement);
        }
        else {
            hasValue = true;
            singleValue = value;
        }
    }
    return singleValue;
};
const singleOrDefault2 = (source, predicate) => {
    let hasValue = false;
    let singleValue = null;
    for (const value of source) {
        if (predicate(value)) {
            if (hasValue === true) {
                throw new InvalidOperationException(ErrorString.MoreThanOneMatchingElement);
            }
            else {
                hasValue = true;
                singleValue = value;
            }
        }
    }
    return singleValue;
};
